<template>
    <section class="layout" :class="{'is-loading': isLoading}">

        <!-- Header //-->
        <header v-if="!isLoading" class="header">
            <nav v-if="hasClient && hasProject" class="navbar navbar-default border-bottom bg-body static-top mb-0">

                <div class="container-fluid">

                    <div class="navbar-header">
                        <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                            <span class="sr-only">Toggle navigation</span>
                            <i class="fa fa-bars" aria-hidden="true"></i>
                        </button>
                        <span class="navbar-brand">
                            <img :src="client.logo_url" width="24" height="24" :alt="client.name">
                        </span>
                    </div>

                    <div id="navbar" class="navbar-collapse collapse">

                        <ol class="nav navbar-nav breadcrumb bg-transparent mb-0">
                            <li><span>{{ project.name }}</span></li>
                            <li><span>Media share</span></li>
                            <slot name="breadcrumb"></slot>
                        </ol>

                        <div class="navbar-right">
                            <div class="container-fluid">
                                <slot name="navbar-right"></slot>
                            </div>
                        </div>
                    </div>

                </div>
            </nav>
        </header>

        <!-- Main //-->
        <main role="main" class="main">
            <slot v-if="!isLoading"></slot>
            <div v-else class="d-flex flex-column align-items-center justify-content-center">
                <spinner :show="isLoading" />
                <span>Please wait loading...</span>
            </div>
        </main>

        <!-- Sidebar //-->
        <transition name="sidebar">
            <aside v-if="sidebarOpen" class="sidebar bg-white" :class="{'is-open': sidebarOpen }">
                <slot name="sidebar"></slot>
            </aside>
        </transition>

        <!-- Footer //-->
        <footer class="footer border-top bg-body">
            <div class="container-fluid">
                <div class="d-flex flex-row justify-content-center p-2">
                    <a :href="poweredBy" target="_blank">
                        <span class="text-muted">Powered by <img src="/images/ca/ca-logo-blue-32x32.png" alt="CA" /></span>
                    </a>
                </div>
            </div>
        </footer>

    </section>
</template>

<script>
import Spinner from '@/components/media/Spinner';

export default {
    name: 'Layout',
    components: {
        Spinner,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        sidebarOpen: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasClient() {
            return Object.keys(this.client).length > 0;
        },
        hasProject() {
            return Object.keys(this.project).length > 0;
        },
        poweredBy() {
            return process.env.POWERED_BY_URL;
        },
    },
}
</script>

<style lang="scss">
@import '~/sass/_variables';

.layout {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto 1fr auto;
    grid-template-areas: "header header header"
        "main main sidebar"
        "footer footer footer";
    background: $body-bg;

    min-height: 100vh;
}

.header {
    grid-area: header;
}

.main {
    grid-area: main;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: flex-start;

    .container-fluid {
        max-width: 1170px;
    }

    .is-loading & {
        justify-content: center;
    }
}

.gallery {
    padding-bottom: 0;
}

.sidebar {
    grid-area: sidebar;
    width: 0;
    overflow-y: auto;
    //white-space: nowrap;

    * {
        transition: none;
    }

    &.is-open {
        width: 462px;
    }
}

.sidebar-enter-active, .sidebar-leave-active {
  transition: all 0s;
}

.sidebar-enter, .sidebar-leave-to {
   width: 462px;
}

.navbar-collapse {
    position: relative;
}

.nav.navbar-nav.breadcrumb {
    position: absolute;
    top: 0;
    left: 50px;
    height: 100%;
    padding: 0;
    font-size: 1.5rem;

    > .active {
        color: $text-color;
    }

    a {
        cursor: pointer;
    }

    span {
        padding: 15px;
    }

    a, span {
        color: $text-color;
    }

    li, span, a {
        position: relative;
        display: inline-block;
        height: 100%;
        vertical-align: middle;
    }

    > li + li:before {
        content: "\3E";
    }

    li a, li span,
    li.active a, li.active span {
        max-width: 300px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    li.active span, li.active:active span, li.active:hover span,
    li.active a, li:active a, li:hover a  {
        transition: all 1s;
        padding: 15px;
        line-height: 20px;
        box-shadow: inset 0 -5px 0 $brand-primary;
    }
}

.sidebar-toggle {
    font-size: 1rem;
    cursor: pointer;

    &.active {
        color: $gray-dark;
    }
}

.gallery-item-actions button.media-item-download:active,
.gallery-item-actions button.media-item-download:hover {
    color: $brand-primary !important;
    i {
        color: $brand-primary !important;
    }
}

.footer {
    grid-area: footer;
}

@media (max-width: $screen-lg-max) {

   .nav.navbar-nav.breadcrumb {
        display: block;
        position: relative;
        left: 30px;

        li, span, a {
            display: block;
            height: auto;
        }

        > li + li:before {
            display: none;
        }
    }

    .layout {
        grid-template-areas:
            "header"
            "main"
            "sidebar"
            "footer";

        grid-template-columns: 100%;

        grid-template-rows:
            auto /* haeder */
            minmax(30%, 1fr) /* main */
            auto /* sidebar */
            auto; /* footer */
    }

    .sidebar {
        min-height: 0;

        &.is-open {
            width: 100%;
        }

        &-toggle {
            display: none;
        }

    }

    nav, aside {
        margin: 0;
    }
}

@media (min-width: $screen-lg-min) {
    .navbar-right {
        margin-right: -30px;
    }
}
</style>
